import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1020e8af = () => interopDefault(import('../pages/group.vue' /* webpackChunkName: "pages/group" */))
const _124ff990 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _3b3d1092 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _3863b982 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3c74f192 = () => interopDefault(import('../pages/individual/_discord_id.vue' /* webpackChunkName: "pages/individual/_discord_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/group",
    component: _1020e8af,
    name: "group"
  }, {
    path: "/privacy",
    component: _124ff990,
    name: "privacy"
  }, {
    path: "/terms",
    component: _3b3d1092,
    name: "terms"
  }, {
    path: "/",
    component: _3863b982,
    name: "index"
  }, {
    path: "/individual/:discord_id?",
    component: _3c74f192,
    name: "individual-discord_id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
